var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CFileDownload',{staticClass:"discount-association__file-download",attrs:{"placeholder":_vm.placeholder,"is-loading":_vm.isLoading,"fileName":"discount_associations.csv"},on:{"download":_vm.downloadDiscountables}})
}
var staticRenderFns = []

export { render, staticRenderFns }